import * as React from 'react';
import { UserLabelColorEnum } from '../../generated-api';

// backend has no "none" value - gray is presented as "no color" on the FE
export const USER_LABEL_NO_COLOR: UserLabelColorEnum = UserLabelColorEnum.Gray;

// presentation colors for the fixed backend palette (API stores the enum name, not hex)
export const USER_LABEL_COLORS: Record<UserLabelColorEnum, string> = {
  green: '#82BB23',
  blue: '#2196F3',
  orange: '#FA6900',
  yellow: '#FFC107',
  red: '#FB390D',
  purple: '#9C27B0',
  gray: '#FFFFFF',
  teal: '#009688',
};

// "no color" first - it is the default
export const USER_LABEL_PICKER_ORDER: UserLabelColorEnum[] = [
  UserLabelColorEnum.Gray,
  UserLabelColorEnum.Green,
  UserLabelColorEnum.Blue,
  UserLabelColorEnum.Teal,
  UserLabelColorEnum.Yellow,
  UserLabelColorEnum.Orange,
  UserLabelColorEnum.Red,
  UserLabelColorEnum.Purple,
];

type Props = {
  color: UserLabelColorEnum;
  size?: number;
};

export const UserLabelColorSwatch = ({ color, size = 16 }: Props) => {
  const isNoColor = color === USER_LABEL_NO_COLOR;
  return (
    <span
      title={isNoColor ? undefined : color}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '4px',
        backgroundColor: USER_LABEL_COLORS[color],
        border: isNoColor ? '1px solid #D0D0D0' : undefined,
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    />
  );
};
